/* eslint-disable */
import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import moment from 'moment';
import qs from 'qs';
import {
  List,
  Button,
  Avatar,
  Table,
  Divider,
  Breadcrumb,
  Tooltip,
  message,
} from 'antd';
import { withQuery } from '@/utils';
import * as actions from '@/models/referrals/actions';
import * as selectors from '@/models/referrals/selectors';
import * as apis from '@/apis';
import styles from './referrals.module.scss';
import InvitationsDialog from '@/components/dialogs/InvitationsDialog';
import { orderPreview } from '@/models/orders/actions';

function calFee(order) {
  const profit = Math.floor(order.profit) // 利润取整数比较
  if (order.referralBinding.type === 1) {
    // 固定金额类型：取整后利润必须 > 固定提成 * 2
    const minProfit = Math.floor(order.referralBinding.per_order_commission * 2)
    if (profit <= minProfit) return 0
    return order.referralBinding.per_order_commission; // 每单固定金额，单位为元
  } else {
    // 比例类型：取整后利润必须 > 比例提成 * 2
    const commission = order.profit * order.referralBinding.per_order_commission_rate
    const minProfit = Math.floor(commission * 2)
    if (profit <= minProfit) return 0
    return commission
  }
}

function getColumns(dispatch, reFetch) {
  return [
    {
      title: '散户',
      key: '_id',
      render: (item) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: 10 }}>
            <Avatar shape="square" size={42} src={item.logo} />
          </div>
          <div>
            <div>{item.binding.retail.user.name || "用户"+item.binding.retail.user.mobile.slice(-4)}</div>
          </div>
        </div>
      ),
    },
    // {
    //   title: '上次结算于',
    //   render: (item) => (
    //     <div>
    //       <div>{dayjs(item.lastSettlementAt).fromNow()}</div>
    //       <small style={{ color: '#b2b2b2' }}>
    //         {dayjs(item.lastSettlementAt).format('YYYY-MM-DD HH:mm')}
    //       </small>
    //     </div>
    //   ),
    // },
    {
      title: '未结算单数',
      render: (item) => (
        <div>
          <h3>{item.count}</h3>
        </div>
      ),
    },
    {
      title: '平台总利润',
      render: (item) => {
        const totalProfit = item.orders.reduce((total, order) => {
          return total + order.profit
        }, 0)

        // const totalProfit = item.orders.reduce((total, order) => {
        //   const tenantFee = order.fee.reduce(
        //     (total, item) => total + item.price,
        //     0
        //   );

        //   const workerFee = order.worker_fee.reduce(
        //     (total, item) => total + item.price,
        //     0
        //   );

        //   return total + (tenantFee - workerFee);
        // }, 0);

        return (
          <div>
            <span>¥{totalProfit.toFixed(2)}</span>
          </div>
        );
      },
    },
    {
      title: '之前月份未结算',
      render: (item) => {
        const total = item.orders.reduce((total, order) => {
          if (moment().month() == moment(order.last_checked_at).month()) {
            return total
          }
          return total + calFee(order);
        }, 0);
        return (
          <div>
            <h3>¥{total.toFixed(2)}</h3>
          </div>
        );
      },
    },
    {
      title: '当月未结算',
      render: (item) => {
        const total = item.orders.reduce((total, order) => {
          if (moment().month() == moment(order.last_checked_at).month()) {
            return total + calFee(order);
          }
          return total;
        }, 0);
        return (
          <div>
            <h3>¥{total.toFixed(2)}</h3>
          </div>
        );
      },
    },
    {
      title: '结算方式',
      render: (item) => {
        const group = _.groupBy(item.orders, 'referralBinding._id');

        function itemRender(binding) {
          return (
            <div key={binding._id}>
              {binding.type === 1
                ? `每单固定${binding.per_order_commission}元`
                : `每单收入的${(binding.per_order_commission_rate * 100).toFixed(2)}%`}
            </div>
          );
        }

        if (Object.keys(group).length > 1) {
          return Object.keys(group).map((key) =>
            itemRender(group[key][0]?.referralBinding)
          );
        } else {
          const key = Object.keys(group)[0];
          return itemRender(group[key][0]?.referralBinding);
        }
      },
    },
  ];
}

let locked = false

function ReffList(props) {
  const { match } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const fetch = useCallback(() => {
    apis
      .getRetailReferralUnbilledList(match.params.id)
      .then((result) => {
        setLoading(false);
        setData(result);
      })
      .catch((error) => {
        setLoading(false);
        message.error(error.message || '发生异常');
      });
  }, []);

  const columns = useMemo(() => {
    return getColumns(dispatch, fetch);
  }, [dispatch, fetch]);

  const renderData = useMemo(() => {
    const retailMap = data?.retails?.reduce((map, retail) => {
      map[retail.user] = retail;
      return map;
    }, {});

    const list = data?.list.map((retail) => {
      return {
        ...retail,
        ...retailMap[retail._id],
      };
    });

    return list;
  }, [data]);

  const handleRowClick = useCallback(
    (item) => () => {
      dispatch(
        orderPreview({
          title: `工单 - ${item.order_no}`,
          id: item._id,
        })
      );
    },
    []
  );

  const [settlementLoading, setSettlementLoading] = useState(false);
  const settlementHandler = useCallback(async () => {
    if (locked) {
      return false;
    }
    const date = new Date()
    // if (date.getDate() < 8) {
    //   message.error('每个月的第7日以后才能结算上月佣金');
    //   return
    // }
    const ids = data.list.reduce((list, retail) => {
      return list.concat(retail.orders.map((order) => order._id));
    }, []);
    locked = true; // 防止重复支付！
    setSettlementLoading(true);

    apis
      .retailReferralConfirmSettlement(match.params.id, { orderIds: ids })
      .then(() => {
        message.success('已结算');
        fetch();
      })
      .catch((err) => {
        message.error(err.message || '结算失败');
      })
      .finally(() => {
        setSettlementLoading(false);
        locked = false;
      });
  }, [data]);

  const totalUnbilledList = useMemo(() => {
    if (!data || !data.list) {
      return 0;
    }

    const date = moment().date()
    const firstDayOfCurrentMonth = moment().startOf('month');
    // 获取上个月的第一天
    const firstDayOfLastMonth = firstDayOfCurrentMonth.subtract(1, 'months').startOf('month');

    return data.list.reduce((total, retail) => {
      return (total += retail.orders.reduce((retailTotal, order) => {
        if (date < 8) {
          if (moment(order.last_checked_at).isBefore(firstDayOfLastMonth)) {
            return retailTotal + calFee(order);
          } else {
            return retailTotal
          }

        } else {
          if (moment().month() == moment(order.last_checked_at).month()) {
            return retailTotal
          } else {
            return retailTotal + calFee(order);
          }
        }
      }, 0));
    }, 0);
  }, [data]);

  const isSettleable = (time) => {
    let val = false;
    const date = moment().date()
    const firstDayOfCurrentMonth = moment().startOf('month');
    // 获取上个月的第一天
    const firstDayOfLastMonth = firstDayOfCurrentMonth.subtract(1, 'months').startOf('month');

    if (date < 8) {
      if (moment(time).isBefore(firstDayOfLastMonth)) {
        val = true;
      }
    } else {
      if (moment().month() == moment(time).month()) {
        val = false;
      } else {
        val = true;
      }
    }
    return val
  }
  useMount(fetch);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>推广员</Breadcrumb.Item>
          <Breadcrumb.Item>{data && (data.retail.realname || (data.retail.user?.name || "用户"+data.retail.user?.mobile.slice(-4)))}</Breadcrumb.Item>
          <Breadcrumb.Item>结算</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      {data && (
        <div className={styles.info}>
          <div className={styles.userInfo}>
            <Avatar shape="square" size={56} src={data.retail.user?.avatar} />
            <div className={styles.userInfoList}>
              <div>姓名: {data.retail.realname || (data.retail.user?.name || "用户"+data.retail.user?.mobile.slice(-4))} </div>
              {/* <div>余额: {data.referral.balance.toFixed(2)}元 </div> */}
              {/* <div>
                上次结算于:{' '}
                {dayjs(data.referral.lastSettlementAt).format(
                  'YYYY-MM-DD HH:mm'
                )}{' '}
              </div> */}
              <div>
                入驻于:{' '}
                {dayjs(data.retail.createdAt).format('YYYY-MM-DD HH:mm')}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: 50 }}>
              <div>可结算总金额</div>
              <div>
                <b style={{ fontSize: 24 }}>{totalUnbilledList.toFixed(2)}</b>元
              </div>
            </div>
            <div style={{ marginRight: 20 }}>
              <Button
                disabled={!totalUnbilledList}
                size="large"
                type="primary"
                loading={settlementLoading}
                onClick={settlementHandler}
              >
                结算
              </Button>
            </div>
            <div className={styles.tips}>
              <div>* 每月8日可结算之前月份佣金</div>
              <div>* 结算后不可撤回，请谨慎操作</div>
            </div>
          </div>
        </div>
      )}
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={renderData || []}
        pagination={false}
        loading={loading}
        expandedRowRender={(record, index, indent, expanded) => {
          if (!expanded) {
            return null;
          }
          return (
            <div className={styles.orders}>
              {record.orders.map((order, idx) => {
                return (
                  <div
                    className={styles.orderItem}
                    key={order._id}
                    onClick={handleRowClick(order)}
                    style={{ background: !isSettleable(order.last_checked_at) ? 'rgba(255,2,2,0.2)' : 'rgba(18,97,56,0.1)' }}
                  // style={{ background: moment().month() == moment(order.last_checked_at).month() ? 'rgba(255,2,2,0.2)' : 'rgba(18,97,56,0.1)' }}
                  >
                    <div>{idx + 1}.</div>
                    <div className={styles.row}>
                      <div>{order.order_no}</div>
                      <div>
                        {order.referralBinding.type === 1
                          ? `每单固定${order.referralBinding.per_order_commission}元`
                          : `每单毛利的${(order.referralBinding.per_order_commission_rate * 100).toFixed(2)}%`}
                      </div>
                      <div>最后修改时间:</div>
                      <div>{moment(order.last_checked_at).format("YYYY-MM-DD h:mm:ss")}</div>
                      <div>{isSettleable(order.last_checked_at) ? '本次可结算' : '本次不可结算'}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        }}
      ></Table>
    </div>
  );
}

export default withQuery(ReffList);
